import { render, staticRenderFns } from "./TrademarkDetail.vue?vue&type=template&id=10bb7387&scoped=true"
import script from "./TrademarkDetail.vue?vue&type=script&lang=js"
export * from "./TrademarkDetail.vue?vue&type=script&lang=js"
import style0 from "./TrademarkDetail.vue?vue&type=style&index=0&id=10bb7387&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bb7387",
  null
  
)

export default component.exports